export const SOUS_TOTAL = 'Soustotal';
export const REMISE = 'Remise';
export const NORMAL = 'Normal';
export const COMMENTAIRE = 'Commentaire';
export const REGROUPEMENT = 'Regroupement';
export const PERSONNALISE = 'Personnalise';
export const LOCATION = 'Location';

export const JOUR = 'Jour';
export const SEMAINE = 'Semaine';
export const MOIS = 'Mois';
export const TRIMESTRIEL = 'Trimestriel';
export const SEMESTRIEL = 'Semestriel';
export const ANNEE = 'Annee';
export const UNITE = 'Unite';
export const POURCENTAGE = 'Pourcentage';

export const MAJORATION = 'Majoration';
export const REDUCTION = 'Reduction';

export const TYPE_REMISE_FRONT_MAJORATION_MONTANT = 'Majoration montant';
export const TYPE_REMISE_FRONT_REMISE_MONTANT = 'Reduction montant';
export const TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE = 'Majoration pourcentage';
export const TYPE_REMISE_FRONT_REMISE_POURCENTAGE = 'Reduction pourcentage';


export const LISTE_UNITES = [
  {
    code: JOUR,
    initiale: 'general.quantity.initialDay',
    libelle: 'general.quantity.day',
    libelleLight: 'general.quantityLight.day',
  },
  {
    code: SEMAINE,
    initiale: 'general.quantity.initialWeek',
    libelle: 'general.quantity.week',
    libelleLight: 'general.quantityLight.week',
  },
  {
    code: MOIS,
    initiale: 'general.quantity.initialMonth',
    libelle: 'general.quantity.month',
    libelleLight: 'general.quantityLight.month',
  },
  {
    code: ANNEE,
    initiale: 'general.quantity.initialYear',
    libelle: 'general.quantity.year',
    libelleLight: 'general.quantityLight.year',
  },
  {
    code: UNITE,
    initiale: 'general.quantity.initialUnity',
    libelle: 'general.quantity.unity',
    libelleLight: 'general.quantityLight.unity',
  },
  {
    code: POURCENTAGE,
    initiale: 'general.quantity.initialPercent',
    libelle: 'general.quantity.percent',
    libelleLight: 'general.quantityLight.percent',
  }];

export const MONTANT = 'Montant';
export const PERSONALISE = 'Personalise';

export const TYPE_DEVIS = 'Devis';
export const TYPE_COMMANDE = 'Commande';
export const TYPE_FACTURE = 'Facture';
export const TYPE_PROPOSITION = 'Proposition';

export const SOUS_TYPE_NORMAL = 'Normal';
export const SOUS_TYPE_AVOIR = 'Avoir';
export const SOUS_TYPE_ACOMPTE = 'Acompte';

export const ETAT_SANS_SUITE = 'SansSuite';
export const ETAT_ENREGISTRE = 'Enregistre';
export const ETAT_BROUILLON = 'Brouillon';
export const ETAT_CLOS = 'Clos';
export const ETAT_FACTURE = 'Facture';
export const ETAT_FACTURE_PARTIELLEMENT = 'FactureePartiellement';
export const ETAT_COMMANDE_PARTIELLEMENT = 'CommandePartiellement';

export const DEVIS_COMMANDE_TARIF = [
  {},
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7487', libelle: '1 an' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7486', libelle: '2 ans' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7485', libelle: '3 ans' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7484', libelle: 'mensuel' },
];

export const LISTE_TAUX_TVA = {
  '0%': 0,
  '5%': 5,
  '7%': 7,
  '20%': 20,
};

export const TYPE_EDITION_DEVIS = 'Devis';
export const AUCUN = 'Aucun';

export const PRODUIT_ID = '00000000-0000-0000-0000-000000000000';

export const EN_ATTENTE_RELANCE_OPTION = 'AttenteRelanceOption';
export const RELANCE_OPTION = 'RelanceOption';
export const BLOQUE = 'Bloque';
export const OPTION = 'Option';
export const BLOCAGE_CLIENT_TOTAL = 'Total';

export const MODULE_GESTION_COMMERCIALE = 'GestionCommerciale';



// WEBPACK FOOTER //
// ./src/configuration/devisConf.js